import React, { useState } from "react";
import PropTypes from "prop-types";
import ButtonComponent from "components/ButtonComponent";
import ErrorComponent from "components/ErrorComponent";
import LoaderComponent from "components/LoaderComponent";
import TextComponent from "components/TextComponent";
import CloseImage from "assets/images/general_old/close.svg";
import { LanguageValidationSchema } from "./utils";
import { CallAPI } from "actions/General";
import CustomModal from "components/CustomModal";

function AddEditLanguage({ editObj, setEditObj, actionPerformedSuccessfully }) {
  console.log(editObj)
  const [loader, setLoader] = useState(false);
  const [loaderType, setLoaderType] = useState("");
  const [apiError, setApiError] = useState("");
  const [values, setValues] = useState({
    name: editObj && editObj.name ? editObj.name : "",
    code: editObj && editObj.code ? editObj.code : "",
  });
  const [errors, setErrors] = useState({
    name: "",
    code: "",
  });

  const updateFormValues = (name, value) => {
    setValues({ ...values, [name]: value });
  };
  const AddUpdateLanguage = async () => {
    console.log("values", values);
    try {
      const recordId = editObj && editObj.id ? editObj.id : null;
      const API_NAME = editObj && editObj.id ? "UPDATE_LANGUAGE" : "ADD_LANGUAGE";
      await LanguageValidationSchema.validate(values, { abortEarly: false });
      const result = await CallAPI(
        API_NAME,
        values,
        recordId,
        setLoader,
        setApiError,
        null
      );
      if (result.status) {
        actionPerformedSuccessfully();
      }
    } catch (error) {
      console.log("error", error);
      const schemaErrors = {};
      error.inner?.forEach((err) => {
        schemaErrors[err.path] = err.message;
      });
      setErrors(schemaErrors);
    }
  };
  return (
    <div className={`custom-modal `}>
      {loader && loaderType === "load_detail" && <LoaderComponent classes="" />}
      {apiError && <ErrorComponent text={apiError} variant="danger" />}
      <div className="detail subscriptions">
        <img
          className="close"
          src={CloseImage}
          onClick={() => setEditObj(null)}
          alt="close"
        />
        <div className="d-flex flex-column gap-3">
          <TextComponent
            classes={""}
            name={"name"}
            value={values.name}
            setValue={updateFormValues}
            error={errors.name}
            label={"title"}
            placeholder={"title"}
            disabled={false}
            required={true}
          />
          <TextComponent
            classes={""}
            name={"code"}
            value={values.code}
            setValue={updateFormValues}
            error={errors.code}
            label={"code"}
            placeholder={"code"}
            disabled={false}
            required={true}
          />

          <div className="ms-auto">
            <ButtonComponent
              text={editObj && editObj.id ? "update" : "create"}
              onClick={AddUpdateLanguage}
              variant="blue-1"
              loading={loader && loaderType === "save"}
              disabled={loader && loaderType === "save"}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
AddEditLanguage.propTypes = {
  editObj: PropTypes.object,
  setEditObj: PropTypes.func.isRequired,
  actionPerformedSuccessfully: PropTypes.func.isRequired,
};
export default AddEditLanguage;
